import { Group } from '@/components/_common';
import {
  WorkOrderItem,
  WorkOrderItemType,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { Descriptions, Modal, ModalProps, Statistic } from 'antd';
import React from 'react';

import { quantityFormatter } from '@/utils/number';
import { useWindowSize } from '@/hooks';
import formatterPrice from '@/utils/number/formatterPrice';
import { isAppPortocar } from '@/index';
import WorkOrderItemPortoBatteryLabelCode from '../WorkOrderItemList/WorkOrderItemPortoBatteryLabelCode';

interface Props extends ModalProps {
  workorderItem?: WorkOrderItem;
}

const breakpoints: Record<string, number> = {
  xl: 1,
  md: 2,
  sm: 2,
  xs: 2,
};

const WorkOrderItemViewModal: React.FC<Props> = ({
  workorderItem,
  ...props
}) => {
  const { breakpoint, isMobile } = useWindowSize();

  const unitPrice = workorderItem?.unitPrice || 0;
  const quantity = workorderItem?.quantity || 0;
  const discount = workorderItem?.discount || 0;
  const isItemService = workorderItem?.type === WorkOrderItemType.Service;

  const discountPercent = discount * 100;
  const discountValue = unitPrice * quantity * discount;

  const amount = unitPrice * quantity - discountValue;

  return (
    <Modal
      title={<strong>{workorderItem?.description}</strong>}
      width={800}
      footer={null}
      {...props}
    >
      <Descriptions
        layout="vertical"
        column={4}
        labelStyle={{ fontWeight: 600 }}
        contentStyle={{ paddingBottom: 16 }}
      >
        <Descriptions.Item
          span={isMobile ? 4 : breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Cód. Fabricante"
        >
          {workorderItem?.manufacturingCode || '-'}
        </Descriptions.Item>

        <Descriptions.Item
          span={isMobile ? 4 : breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Fabricante"
        >
          {workorderItem?.manufacturer?.name || '-'}
        </Descriptions.Item>

        <Descriptions.Item
          span={breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Subárea"
        >
          {workorderItem?.subArea?.name ?? '-'}
        </Descriptions.Item>

        <Descriptions.Item
          span={breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Terceirizado?"
        >
          {workorderItem?.isInternal ? 'Não' : 'Sim'}
        </Descriptions.Item>

        <Descriptions.Item
          span={breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Fornecedor"
        >
          {workorderItem?.supplier?.name || '-'}
        </Descriptions.Item>

        {isItemService && (
          <Descriptions.Item
            span={breakpoints[breakpoint]}
            style={{ padding: 0 }}
            label="Funcionário"
          >
            {workorderItem?.employee?.name || '-'}
          </Descriptions.Item>
        )}

        <Descriptions.Item
          span={breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Quantidade"
        >
          {formatterPrice(quantity)}
        </Descriptions.Item>

        <Descriptions.Item
          span={breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Preço Unit."
        >
          {formatterPrice(unitPrice)}
        </Descriptions.Item>

        <Descriptions.Item
          span={breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Desconto(%)"
        >
          <Group gap={5}>
            {formatterPrice(discountPercent)}
            <span>%</span>
          </Group>
        </Descriptions.Item>

        <Descriptions.Item
          span={!isMobile ? 2 : breakpoints[breakpoint]}
          style={{ padding: 0 }}
          label="Desconto(R$)"
        >
          {formatterPrice(discountValue)}
        </Descriptions.Item>

        <Descriptions.Item
          span={isMobile ? 4 : 2}
          style={{ padding: 0 }}
          label="Preço unitário de custo"
        >
          {formatterPrice(workorderItem?.unitCost || 0)}
        </Descriptions.Item>

        <Descriptions.Item
          span={isMobile ? 4 : 2}
          style={{ padding: 0 }}
          label="Valor Total"
        >
          <Statistic
            value={quantityFormatter(amount)}
            prefix="R$"
            valueStyle={{ color: '#38B3B6' }}
          />
        </Descriptions.Item>
      </Descriptions>

      {isAppPortocar && !!workorderItem?.portoBatteryLabelCode && (
        <WorkOrderItemPortoBatteryLabelCode
          portoBatteryLabelCode={workorderItem.portoBatteryLabelCode}
        />
      )}
    </Modal>
  );
};

export default WorkOrderItemViewModal;
